export default "__VITE_ASSET__D6ERcaOj__"